(function () {
  /**
   * @ngdoc module
   * @name akitabox.mobile.directives.buildingListItem
   */
  angular
    .module("akitabox.mobile.directives.buildingListItem", ["ui.router"])
    .directive("abmBuildingListItem", AbmBuildingListItemDirective);

  /**
   * @ngdoc
   * @module akitabox.mobile.directives.buildingListItem
   * @name AbmBuildingListItemDirective
   *
   * @description
   * `<abm-building-list-item>` is an expandable building list item
   * with sub items for building specific navigation
   *
   * @restrict E
   *
   * @usage
   * <hljs lang="html">
   *
   * <abm-building-list-item
   *         ng-repeat="building in vm.buildings"
   *         building="building"
   *         expanded="vm.building.length === 1">
   * </abm-building-list-item>
   *
   * </hljs>
   */
  function AbmBuildingListItemDirective() {
    return {
      restrict: "E",
      templateUrl:
        "app/mobile/directives/building-list-item/building-list-item.html",
      controller: AbmBuildingListItemController,
      controllerAs: "vm",
      bindToController: true,
      scope: {
        building: "=",
      },
    };
  }

  /** @ngInject */
  function AbmBuildingListItemController($state) {
    var self = this;

    // Functions
    self.goToDetails = goToDetails;

    function goToDetails() {
      var params = { buildingId: self.building._id };

      $state.go("app.building.detail", params);
    }
  }
})();
